let page = document.getElementById('js-black');
let navbar = document.querySelector('.navbar__top');
if (page) {
    const logo = document.querySelector('.logo');
    let scrollTrigger = document.querySelector('.js-bg-trigger');
    navbar.classList.add('navbar__top--dark');
    logo.classList.add("u-fill-white");
    window.addEventListener('scroll', function() {
        if (window.scrollY < scrollTrigger.offsetTop - 200) {
            page.classList.remove('change-color');
            navbar.classList.add('navbar__top--dark');
            logo.classList.add("u-fill-white");
        } else {
            page.classList.add('change-color');
            navbar.classList.remove('navbar__top--dark');
            logo.classList.remove("u-fill-white");
        }
    });
}

let prevScrollPos = window.scrollY;
window.addEventListener('scroll', function() {
    if (window.scrollY < 200) {
        navbar.style.top = "0";
    } else {
        let currentScrollPos = window.scrollY;
        prevScrollPos > currentScrollPos ? navbar.style.top = "0" : navbar.style.top = "-80px";
        prevScrollPos = currentScrollPos;
    }
});
